import { APP_VERSION, AUTO_UPDATE_ON_VERSION_CHANGE } from './appVersion';

// Centralized configuration values
const API_URL = import.meta.env.VITE_API_URL || 
  (import.meta.env.MODE === "production"
    ? "https://api.colefaxjobcards.co.za/api"
    : "http://localhost:8002");

// App configuration
export const config = {
  API_URL,
  APP_NAME: import.meta.env.VITE_APP_NAME || "Colefax Job Cards", 
  ASSET_URL: API_URL,
  VAPID_PUBLIC_KEY: import.meta.env.VITE_VAPID_PUBLIC_KEY || '',
  APP_VERSION,
  AUTO_UPDATE_ON_VERSION_CHANGE,
};

// Helper function to get absolute URLs for assets
export function getAssetUrl(path: string): string {
  // Ensure path starts with a slash
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  // Detect mobile device
  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  // Add cache busting for mobile devices
  if (isMobile) {
    const timestamp = Date.now();
    const separator = normalizedPath.includes('?') ? '&' : '?';
    return `${API_URL}${normalizedPath}${separator}_t=${timestamp}`;
  }
  
  // API_URL already includes /api in production, so just append the path
  return `${API_URL}${normalizedPath}`;
}

// Helper function to get task image URLs (uses the working /tasks/image/{filename} route)
export function getTaskImageUrl(filename: string): string {
  const isAndroid = /Android/i.test(navigator.userAgent);
  const base = config.API_URL.replace(/\/+$/, '');
  const apiBase = /\/api$/.test(base) ? base : `${base}/api`;
  
  // Add debugging for Android devices
  if (isAndroid) {
    console.log('getTaskImageUrl: Android device detected', {
      filename,
      apiBase,
      userAgent: navigator.userAgent
    });
  }
  
  // Simplified approach - no cache busting, let backend handle it
  return `${apiBase}/tasks/image/${filename}`;
}

// Helper function to get signature image URLs (uses /signatures/image/{filename})
export function getSignatureImageUrl(filename: string): string {
  const base = config.API_URL.replace(/\/+$/, '');
  const apiBase = /\/api$/.test(base) ? base : `${base}/api`;
  
  // Simplified approach - no cache busting, let backend handle it
  return `${apiBase}/signatures/image/${filename}`;
}

export default config; 